import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BackofficeInvoiceInstTransformer  {
    _originalTypeClassName = "zERP.BO.BackofficeInvoiceInstTransformer";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BackofficeInvoiceInstTransformer.translate = translateService;
}
this.BackofficeInvoiceInstTransformerKey = null;
this._key = this.BackofficeInvoiceInstTransformerKey = 0; 
}

static translate: TranslateService;
_key: any;
private _BackofficeInvoiceInstTransformerKey:any;
get BackofficeInvoiceInstTransformerKey(): any {
    return this._BackofficeInvoiceInstTransformerKey;
  }
set BackofficeInvoiceInstTransformerKey(value: any) {
    this._BackofficeInvoiceInstTransformerKey = value;
    this._key = value;
  }

static GetGroupKey(document: any): any{return Joove.Common.safeNumber(document.invoiceId) + "";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BackofficeInvoiceInstTransformerKey == null || $this.BackofficeInvoiceInstTransformerKey == 0;
            }


}